const Roles = () => [
  { id: "admin", label: "Admin" },
  { id: "operator", label: "Operator" },
  { id: "superuser", label: "Super user" },
  { id: "user", label: "User" },
];

export default Roles;
